import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "", company_name: "" });
  const [accept, setAccept] = useState(false);
  const [loading, setLoading] = useState(false);
  const { setData } = useAuth();
  const navigate = useNavigate();

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!accept) {
      toast.error("É necessário aceitar os Termos de Uso e a Política de Privacidade.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", { ...form, accept_terms: accept });
      setData(data);
      toast.success("Conta criada! Vamos configurar sua empresa.");
      navigate("/app/onboarding");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-4">
      <div className="mb-8"><Logo size="lg" /></div>
      <Card className="w-full max-w-md border-slate-200 shadow-sm">
        <CardHeader>
          <CardTitle className="text-2xl font-display">Criar conta grátis</CardTitle>
          <CardDescription>7 dias de teste do plano Profissional, sem cartão.</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="name">Seu nome</Label>
              <Input id="name" data-testid="register-name" required className="h-12" value={form.name} onChange={set("name")} placeholder="João Silva" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="company">Nome da empresa (opcional)</Label>
              <Input id="company" data-testid="register-company" className="h-12" value={form.company_name} onChange={set("company_name")} placeholder="Silva Refrigeração" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="email">E-mail</Label>
              <Input id="email" data-testid="register-email" type="email" required className="h-12" value={form.email} onChange={set("email")} placeholder="voce@empresa.com.br" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Senha</Label>
              <Input id="password" data-testid="register-password" type="password" required minLength={6} className="h-12" value={form.password} onChange={set("password")} placeholder="Mínimo 6 caracteres" />
            </div>
            <div className="flex items-start gap-2.5">
              <Checkbox id="terms" data-testid="register-terms" checked={accept} onCheckedChange={setAccept} className="mt-0.5" />
              <Label htmlFor="terms" className="text-sm text-slate-600 font-normal leading-snug">
                Li e aceito os <Link to="/termos" className="text-sky-700 underline" target="_blank">Termos de Uso</Link> e a{" "}
                <Link to="/privacidade" className="text-sky-700 underline" target="_blank">Política de Privacidade</Link>.
              </Label>
            </div>
            <Button type="submit" className="w-full h-12 bg-sky-600 hover:bg-sky-700 text-white active:scale-[0.98] transition-transform"
                    disabled={loading} data-testid="register-submit-btn">
              {loading ? "Criando conta..." : "Começar grátis"}
            </Button>
          </form>
          <p className="mt-4 text-sm text-center text-slate-500">
            Já tem conta?{" "}
            <Link to="/login" className="text-sky-700 font-medium hover:underline" data-testid="login-link">Entrar</Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
